export default __webpack_public_path__ + "static/media/youtube.c783955e.svg";